import React, { Component } from 'react';

import flightdata from '../constants/data.json';
import * as constClass from '../constants/agent.js';
//import airports from '../constants/airports';
import FlightsList from './FlightsList';
import AirportSuggestionsInput from './AirportSuggestionsInput';
import SocialShareBar from './SocialShareBar'

// Images
import example_ticket from '../images/example_ticket.png'

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";


class FlightsForm extends Component {
  constructor(props) {
    super(props);
    var oneWeekLater = new Date(+new Date() + 86400000 * 7); // Set default value to one week from now
    this.state = {
      from: 'SGN',
      to: 'BKK',
      date: oneWeekLater,
      flightData: null,
      loadingFlights: false,
      firstSearchDone: false
    };
    //console.log("constructor flightData:")
    //console.log(typeof this.state.flightData)
    //console.log(this.state.flightData)
    if (this.state.flightData !== null && this.state.flightData !== undefined) {
      console.log(this.state.flightData.length)
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeTo = this.onChangeTo.bind(this);
    this.onChangeFrom = this.onChangeFrom.bind(this);
  }


  onChangeTo = (event, { newValue }) => {
    this.setState({
      to: newValue
    });
  };

  onChangeFrom = (event, { newValue }) => {
    this.setState({
      from: newValue
    });
  };

  handleChange = name => event => {
    this.setState({[name]: event.target.value});
    console.log(this.state[name])
  }

  handleChangeDatePicker = date => {
    this.setState({date: date});
  }

  parse_date (dateObj) {
    const month = dateObj.getUTCMonth() + 1; //months from 1-12
    const day = dateObj.getDate();
    const year = dateObj.getUTCFullYear();

    const newdate = year + "-" + month + "-" + day;

    return newdate
  }

  async fetchFlights(url) {
    this.setState({ flightData: null})
    await this.setState({ loadingFlights: true})
    //console.log("Fetching flights");
    //console.log("this.state.flightData")
    //console.log(this.state.flightData)
    //await this.setState({ flightData: flightdata.data})
    console.log("Requesting flight data from api.skypicker.com through the backend")
    const date = this.parse_date(this.state.date)
    const response = await fetch(url, {
      method: "post",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },

      //make sure to serialize your JSON body
      body: JSON.stringify({
        fly_to: this.state.to,
        fly_from: this.state.from,
        fly_date: date
      })
    })

    const json = await response.json()
    const data = json.data
    this.setState({ flightData: data})
    await this.setState({ loadingFlights: false})
    this.setState({ firstSearchDone: true})
  }

  async handleSubmit(event) {
    event.preventDefault();
    const flyFrom = event.target.elements[0].value;
    const flyTo = event.target.elements[1].value;
    const flyDate = event.target.elements[2].value;

    //const flight_api_url= `https://api.skypicker.com/flights?flyFrom=${flyFrom}&to=${flyTo}&dateFrom=${flyDate}&dateTo=${flyDate}&partner=skypicker&limit=50&max_stopovers=0`;
    //alert('A name was submitted: ' + flight_api_url);
    const backend_skypicker_url = constClass.IS_LOCAL_INSTANCE ? constClass.LOCAL_BACKEND_URL + '/ticket/skypicker/' : constClass.BACKEND_URL + '/ticket/skypicker/'
    await this.fetchFlights(backend_skypicker_url);
  }

  render() {
    return (
      <div className="container-fluid bg-light">
        <div className="row justify-content-center">
          <div className="col">
            <p class="h2">Generate your fake flight ticket</p>
            <SocialShareBar />
          </div>
        </div>
        <div className="row justify-content-center mt-4">
          <div className="col-xs-12 col-lg-7">
            <a href="https://api.onwardflightticket.com/static/example_ticket.png" title="">
              <img src="https://api.onwardflightticket.com/static/example_ticket.png" class="img-fluid float-right w-25" alt="Dummy Ticket Example" />
            </a>
            <p class="text-justify">
              Generate your free fake flight ticket by searching for flights below.
              The dummy ticket contains real flight data, your name and birthdate.
              You can use it for whatever purpose suits you, for example:
              <ul>
               <li><b>proof of onward travel</b></li>
               <li><b>visa application</b></li>
               <li><b>prank your friends</b></li>
              </ul>
              Please keep in mind, it is <strong>not a real flight ticket</strong> but exactly looks like one!
              The ticket does not contain a verifiable PNR number.
            </p>
          </div>
        </div>
        <div className="row justify-content-center mt-4">
          <div class="col-xs-12 col-lg-9">
            <div class="card">
              <div class="card-body">
                <form onSubmit={this.handleSubmit}>
                <div class="form-row justify-content-center">

                  <div class="col-xs-12 col-lg-4">
                    <AirportSuggestionsInput
                      onChange = {this.onChangeFrom}
                      value = {this.state.from}
                      description = "From"
                    />
                  </div>

                  <div class="col-xs-12 col-lg-4">
                    <AirportSuggestionsInput
                      onChange = {this.onChangeTo}
                      value = {this.state.to}
                      description = "To"
                    />
                  </div>
                  <div class="col-xs-12 col-lg-4">
                    <div class="row">
                      <div class="col">
                        <strong>When</strong>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col">
                        <DatePicker
                          onChange = {date => {
                            this.setState({date: date});
                            console.log("type of date")
                            console.log(typeof this.state.date)
                          }}
                          selected = {this.state.date}
                          dateFormat="dd/MM/yyyy"
                          className="form-control form-control-lg"
                          todayButton={"Today"}
                          placeholderText="When"
                        />
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="form-row mt-4">
                    <div class="col">
                      <button class="btn btn-success btn-lg btn-block" type="submit">Find Flights!</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <br/>
        </div>
        <div className="row justify-content-center">
          <FlightsList flightData={this.state.flightData} loadingFlights={this.state.loadingFlights} firstSearchDone={this.state.firstSearchDone}/>
        </div>
      </div>

    );
  }
}

export default FlightsForm;
